jQuery("[class^='wpforms-field-']").on("change", function () {
	if (jQuery(this).val()) {
		jQuery(this).prev().addClass("wpforms-valid-label");
	}
});
